import React from 'react';

import {useCharacter} from '../character-context';

import css from './sheet.module.css';

/** оставшиеся кости здоровья по размерам */
export const HitDice: React.FC = () => {
	const {character} = useCharacter();
	return (
		<div className={css.healthStat}>
			<dt className={css.statLabel}>Кости здоровья</dt>
			<dd className={css.hitDice}>
				{character.hitDice.map(({die, count, spent}) => (
					<span key={die} className={css.hitDie}>
						<span className={css.hitPointsCurrent}>{count - spent}</span>
						<span className={css.hitPointsMax}>
							/ {count} d{die}
						</span>
					</span>
				))}
			</dd>
		</div>
	);
};
